// extracted by mini-css-extract-plugin
module.exports = {"modalBtn":"styles_modalBtn__1KKSi","file":"styles_file__1_HM8"};